<template>
  <el-tabs type="border-card" class="tabs">
    <el-tab-pane :label="$t('basicData.regionalInformation')">
      <Region />
    </el-tab-pane>
    <el-tab-pane :label="$t('basicData.icmsTaxReferenceTable')">
      <ICMS />
    </el-tab-pane>
    <el-tab-pane :label="$t('basicData.inlandWaterwayTransportFee')">
      <TransportationFee />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: 'DistrictManagement',
  components: {
    Region: () => import('@/views/finance/basicData/districtManagement/cmp/region.vue'),
    ICMS: () => import('@/views/finance/basicData/districtManagement/cmp/icms.vue'),
    TransportationFee: () => import('@/views/finance/basicData/districtManagement/cmp/transportationFee.vue')
  }
};
</script>

<style scoped lang="scss">
.tabs {
  border: none;
  height: 100%;

  ::v-deep .el-tabs__content {
    padding: 10px !important;
  }
}
</style>
